import { render, staticRenderFns } from "./order_evaluate_detail.vue?vue&type=template&id=381358eb"
import script from "./order_evaluate_detail.vue?vue&type=script&lang=js"
export * from "./order_evaluate_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports